import React from 'react';
import _ from 'lodash';
import { formatFilesize } from './helpers/cellFormatters';

const FileEntry = ({ item }) => (
    <>
        {item.filename}
        {item.downloadUrl && (
            <>
                <span className="small"> {formatFilesize(item.fileSize)}</span>
                <div className="btn-group btn-group-xs">
                    <a
                        className="btn btn-link"
                        download={item.filename}
                        href={item.downloadUrl}
                    >
                        <span className="fa fa-circle-down" />
                    </a>
                </div>
            </>
        )}
    </>
);

const File = ({ params }) => {
    let value = params?.value;

    if (!value) {
        return <></>;
    }

    if (!_.isArray(value)) {
        value = [value];
    }

    return (
        <>
            {value.map((item, index) => (
                <React.Fragment key={index}>
                    <FileEntry item={item} />
                    {index !== value.length - 1 && <br />}
                </React.Fragment>
            ))}
        </>
    );
};

export default File;
